<template lang="html">
  <root class="admin-dish-edit">

    <admin-nav></admin-nav>
    <page-header name="Edit dish" :count="false"></page-header>

    <!-- Form -->
    <div class="container">
      <div class="row">
        <div class="col m6">
          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Name (EN)</label>
                <input type="text" v-model="dish.name.en">
              </div>
            </div>

            <div class="col m6">
              <div class="mui-textfield">
                <label>Name (AR)</label>
                <input type="text" v-model="dish.name.ar">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <label>Description (EN)</label>
              <textarea class="materialize-textarea" v-model="dish.description.en"></textarea>
            </div>

            <div class="col m6">
              <label>Description (AR)</label>
              <textarea class="materialize-textarea" v-model="dish.description.ar"></textarea>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Price</label>
                <input type="number" v-model="dish.price"
                maxlength="7" 
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
              </div>
            </div>

            <div class="col m6">
              <div class="mui-select">
                <select v-model="dish.type">
                  <option value="dessert">Dessert</option>
                  <option value="main_dish">Main dish</option>
                  <option value="breakfast">Breakfast</option>
                </select>
                <label>Type</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="file-field input-field">
                <div class="btn">
                  <span>Photo</span>
                  <input type="file" accept="image/jpeg" @change="uploadPhoto($event)">
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" placeholder="Compressed .jpeg, 1:1">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col m6">
          <table class="bottom-line">
            <tbody>
              <tr>
                <th>Name (EN)</th>
                <td>{{dish.name.en}}</td>
              </tr>
              <tr>
                <th>Name (AR)</th>
                <td>{{dish.name.ar}}</td>
              </tr>
              <tr>
                <th>Description (EN)</th>
                <td>{{dish.description.en}}</td>
              </tr>
              <tr>
                <th>Description (AR)</th>
                <td>{{dish.description.ar}}</td>
              </tr>
              <tr>
                <th>Price</th>
                <td>{{dish.price}}</td>
              </tr>
              <tr>
                <th>Type</th>
                <td>{{dish.type}}</td>
              </tr>
              <tr>
                <th>Display photo</th>
                <td><img :src="displayPhotoPreview" class="photo"></td>
              </tr>
              <tr>
                <th>Cover photo</th>
                <td><img :src="coverPhotoPreview" class="photo"></td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>



      <div class="row">
        <div class="col m4 offset-m4">
          <a class="waves-effect waves-light btn" :disable="isSending" @click="update">Update</a>
        </div>
      </div>
    </div>

  </root>
</template>

<script>
import * as firebase from "firebase";

export default {
  data() {
    return {
      dish: {
        name: {
          en: "",
          ar: "",
        },
        description: {
          en: "",
          ar: "",
        },
        price: "",
        type: "",
      },

      displayPhotoPreview: "",
      coverPhotoPreview: "",
      isSending: false,
    };
  },

  methods: {
    // Collect dish
    collectDish() {
      //let userKey = this.$route.params.userKey;
      //let businessKey = this.$route.params.businessKey;
      let dishKey = this.$route.params.dishKey;

      firebase
        .database()
        .ref("dishes/" + dishKey)
        .once("value")
        .then((dishSnap) => {
          let dishData = dishSnap.val();

          // Bind
          this.dish.name = dishData.name;
          this.dish.description = dishData.description;
          this.dish.price = dishData.price;
          this.dish.type = dishData.type;

          // Display photo
          var displayPhotoKey = null;
          if (dishData.is_display_photo_updated == true) {
            displayPhotoKey = dishSnap.key;
          } else {
            displayPhotoKey = dishData.old_key;
          }

          firebase
            .storage()
            .ref(
              "dish/display/" +
                displayPhotoKey /*this.$route.params.dishKey*/ +
                ".jpeg"
            )
            .getDownloadURL()
            .then((display) => {
              this.displayPhotoPreview = display + ".jpeg";
            })
            .catch((error) => {
              // A full list of error codes is available at
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case "storage/object-not-found":
                  console.log("File doesn't exist");
                  break;
                case "storage/unauthorized":
                  console.log(
                    "User doesn't have permission to access the object"
                  );
                  break;
                case "storage/canceled":
                  console.log("User canceled the upload");
                  break;
                case "storage/unknown":
                  console.log(
                    "Unknown error occurred, inspect the server response"
                  );
                  break;
              }
            });

          // Cover photo
          var coverPhotoKey = null;
          if (dishData.is_cover_photo_updated == true) {
            coverPhotoKey = dishSnap.key;
          } else {
            coverPhotoKey = dishData.old_key;
          }
          firebase
            .storage()
            .ref(
              "dish/cover/" +
                coverPhotoKey /*this.$route.params.dishKey*/ +
                ".jpeg"
            )
            .getDownloadURL()
            .then((cover) => {
              this.coverPhotoPreview = cover + ".jpeg";
            })
            .catch((error) => {
              // A full list of error codes is available at
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case "storage/object-not-found":
                  console.log("File doesn't exist");
                  break;
                case "storage/unauthorized":
                  console.log(
                    "User doesn't have permission to access the object"
                  );
                  break;
                case "storage/canceled":
                  console.log("User canceled the upload");
                  break;
                case "storage/unknown":
                  console.log(
                    "Unknown error occurred, inspect the server response"
                  );
                  break;
              }
            });
        });
    },

    // Upload Photo
    uploadPhoto(event) {
      // Collect photo
      let photo = event.target.files || event.dataTransfer.files;

      // Validate
      if (!photo.length || !this.$route.params.dishKey) {
        Materialize.toast("Unable to upload photo", 4000);
        return;
      }

      var reader = new FileReader();
      reader.onload = (e) => {
        this.displayPhotoPreview = e.target.result;
        this.coverPhotoPreview = e.target.result;
      };

      reader.readAsDataURL(photo[0]);

      this.photos = [
        { type: "cover", file: photo[0] },
        { type: "display", file: photo[0] },
      ];

      // Upload photos
      _.forEach(this.photos, (photo) => {
        firebase
          .storage()
          .ref("dish/" + photo.type + "/" + this.$route.params.dishKey + ".jpeg")
          .put(photo.file)
          .then((photoSnap) => {

            Materialize.toast(`Uploaded ${photo.type} photo`, 4000);

            if (photo.type == "display") {
              firebase
                .database()
                .ref("dishes/" + this.$route.params.dishKey)
                .update({ is_display_photo_updated: true });
            } else if (photo.type == "cover") {
              firebase
                .database()
                .ref("dishes/" + this.$route.params.dishKey)
                .update({ is_cover_photo_updated: true });
            }
          });
      });
    },

    // Update
    update() {
      //let userKey = this.$route.params.userKey;
      //let businessKey = this.$route.params.businessKey;
      let dishKey = this.$route.params.dishKey;

      // All fields are required
      if (
        !this.dish.name.en ||
        !this.dish.name.ar ||
        !this.dish.description.en ||
        !this.dish.description.ar ||
        !this.dish.price ||
        !this.dish.type
      )
        return Materialize.toast("All fields are required", 4000);

      // Prevent invalid userkey
      if (!dishKey) {
        return Materialize.toast("Unable to process", 4000);
      }

      this.isSending = true;

      // Push
      firebase
        .database()
        .ref("dishes/" + dishKey)
        .update(this.dish)
        .then(() => {
          Materialize.toast("Updated", 4000);
          this.$router.push({ name: "Dishes" });
        });
    },
  },

  // Mounted
  mounted() {
    this.collectDish();
  },
};
</script>

<style lang="scss">
.admin-dish-edit {
  .photo {
    height: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/DishEdit.vue